import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Resume from './pages/Resume';
import JsonFormatter from './pages/DevTools/JsonFormatter';
import Base64Encode from './pages/DevTools/Base64Encode';
import Base64Decode from './pages/DevTools/Base64Decode';
import JwtDecode from './pages/DevTools/JwtDecode';
import MeetingArea from './pages/MeetMe/MeetingArea';
import BlogIndex from './pages/Blog/Index';
import BlogPost from './pages/Blog/Post';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="me" element={<Resume />} />
            <Route path="dev-tools/json-formatter" element={<JsonFormatter />} />
            <Route path="dev-tools/base64-encode" element={<Base64Encode />} />
            <Route path="dev-tools/base64-decode" element={<Base64Decode />} />
            <Route path="dev-tools/jwt-decode" element={<JwtDecode />} />
            <Route path="meet-me" element={<MeetingArea />} />
            <Route path="blog" element={<BlogIndex />} />
            <Route path="blog/:slug" element={<BlogPost />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
